import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csgoto(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
return(
      <div>
      <Sides/>
   
      <Helmet>
 
 <title>Learn Free PHP Goto Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php goto tutorial for beginners.goto in Php is is used to transfer the program control from one location to another location. Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php break goto,vscode php goto definition,php switch goto another case,php if else goto,tutorial for begineers,Php goto,Php Goto for,Php goto,php goto url,php goto function,Php goto for loop,goto in Php" />
 <link rel="canonical" href="https://www.codeexampler.com/php-goto" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php Goto</h1>
    <div className="first">
        <a href="/php-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Php goto keyword:</h2>
<p className="mt-4 para">The Php goto keyword in Php programming transfers the program control from one location to another location.</p>



<h2 className="headings">Php goto syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-3">|</span>
            {"\n"}
            <span className="qwerty-3">|</span>
            {"\n"}
            <span className="qwerty-4">table </span>
            <span className="qwerty-10">name</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-3">|</span>
            {"\n"}
            <span className="qwerty-3">|</span>
            {"\n"}
            <span className="qwerty-3">|</span>
            {"\n"}
            <span className="qwerty-6">Goto </span>
            <span className="qwerty-4">table </span>
            <span className="qwerty-10">name</span>
            {"\n"}{"\n"}
         
          </code>
        </pre>
      </div>  




<h2 className="headings">Q-Write a Program on Php goto Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-5">1</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-1">Message</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6">echo </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3">."</span>
            <span className="qwerty-4">\</span>
            <span className="qwerty-10">n</span>
          
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-5">$</span>
              <span className="qwerty">a</span>
                <span className="qwerty-7">--</span>
              <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-2">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">&#62;</span>
            <span className="qwerty">= </span>
            <span className="qwerty-5">0</span>
            <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-4">&#123;</span>
              {"\n"}
              <span className="qwerty-10">goto </span>
              <span className="qwerty-1">Message</span>
              <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">1</span>
              {"\n"}
              <span className="qwerty-6">0</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2"> For loop in goto and Check <a href="https://www.codeexampler.com/php-switch">Switch Case PHP</a></h2>



<h2 className="headings">Q-Write a Program on Php goto Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty-2">for </span>
            <span className="qwerty-4">(</span>
              <span className="qwerty">$</span>
            <span className="qwerty-7">i</span>
            <span className="qwerty-4"> = </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-4">; </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">i </span>
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-4">= </span>
            <span className="qwerty-6">12</span>
            <span className="qwerty-4">; </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">i</span>
            <span className="qwerty">++</span>
            <span className="qwerty-4">)</span>
              {"\n"}
              <span className="qwerty-4">&#123;</span>
              {"\n"}
              <span className="qwerty-9">if </span>
              <span className="qwerty-4">(</span>
              <span className="qwerty">$</span>
            <span className="qwerty-7">i</span>
            <span className="qwerty-4"> == </span>
            <span className="qwerty-6">5</span>
            <span className="qwerty-4">)</span>
              {"\n"}
              <span className="qwerty-4">&#123;</span>
              {"\n"}
              <span className="qwerty-6">goto </span>
            <span className="qwerty-4">abc</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty">$</span>
                <span className="qwerty-7">i</span>
              <span className="qwerty-3">."</span>
              <span className="qwerty">\</span>
                <span className="qwerty-7">n</span>
            
              <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-10">echo </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">CodeExampler</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-4">abc</span>
              <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-4">use </span>
              <span className="qwerty-6">goto</span>
              <span className="qwerty-9">";</span>
              {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">1</span>
              {"\n"}
              <span className="qwerty-6">2</span>
              {"\n"}
              <span className="qwerty-6">3</span>
              {"\n"}
              <span className="qwerty-6">4</span>
              {"\n"}
              <span className="qwerty-4">use</span>
              <span className="qwerty-5"> goto</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className="headings">-Write a Program on Php goto by using if-else Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4"> = </span>
            <span className="qwerty-6">4</span>
            <span className="qwerty-4">; </span>
            {"\n"}
            <span className="qwerty-9">if </span>
              <span className="qwerty-4">(</span>
              <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-4">= </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-4">)</span>
              {"\n"}
              <span className="qwerty-4">&#123;</span>
              {"\n"}
            <span className="qwerty">goto </span>
            <span className="qwerty-7">Message</span>
            <span className="qwerty-4">;</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-9">else</span>
              {"\n"}
              <span className="qwerty-4">&#123;</span>
              {"\n"}
              <span className="qwerty-10">echo </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">CodeExampler</span>
            <span className="qwerty-4">";</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-7">Message</span>
              <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-10">echo </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty">Hello</span>
            <span className="qwerty-3"> Ram </span>
            <span className="qwerty">\</span>
                <span className="qwerty-7">n</span>
             
              <span className="qwerty-4">";</span>
              {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-4">Har Har </span>
              <span className="qwerty-3">Mahadev</span>
              <span className="qwerty-9">";</span>
              {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-4">Hello </span>
              <span className="qwerty-5">Ram</span>
              {"\n"}
              <span className="qwerty-3">Har Har </span>
              <span className="qwerty-6">Mahadev </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/php-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csgoto;
